function state() {
  return {
    commissions: [],
    commission: {},
    commissionAll: {
      header: {},
      items: [],
    }, // for mobile lazy loading
    commissionMeta: {},
    commissionUserIds: [],
    commissionValues: [],
    self: {},
    commissionDetail: [],
    commissionDetailMeta: {},
    commissionDetailQuickView: [],
  };
}

export default state;
